import {API, ApiResponseBase, CustomAxiosError} from "../../../../../logics/api-config";
import {useQuery, UseQueryResult} from "react-query";
import {IStripeTransactionsDetail} from "../../../../../utils/interfaces/Accounting/Recap/IStripeTransactionsDetail";


export interface ApiResponse extends ApiResponseBase {
    data: IStripeTransactionsDetail[];
}

async function doGet(ris_id: number, year: string, month: string): Promise<IStripeTransactionsDetail[]> {
    const response = await API.get(`/accounting/recap/restaurant/${ris_id}/stripe_transactions/${year}/${month}`);
    return response?.data.data;
}

const useApiGetStripeTransactionsDetail = (
    ris_id: number,
    year: string,
    month: string,
    options: any = {}
): UseQueryResult<IStripeTransactionsDetail[], CustomAxiosError> => {
    return useQuery<IStripeTransactionsDetail[], CustomAxiosError>(
        ["getStripeTransactionsDetail", ris_id, year, month],
        () => doGet(ris_id, year, month),
        { ...options }
    );
};

export default useApiGetStripeTransactionsDetail;